/**
 * Centralized environment configuration
 * This file provides a single source of truth for all environment variables
 * with proper typing and default values
 */

export const envConfig = {
   // Base URL Configuration
   baseUrl: process.env.NEXT_PUBLIC_BASE_URL || '',
  // API Configuration
  apiProductUrl: process.env.NEXT_PUBLIC_API_PRODUCT_URL || '',
  apiCartUrl: process.env.NEXT_PUBLIC_API_CART_URL || '',
  apiBaseUrl: process.env.NEXT_PUBLIC_API_BASE_URL || '',
  apiInventoryUrl: process.env.NEXT_PUBLIC_API_INVENTORY_URL || '',
  apiCustomerUrl: process.env.NEXT_PUBLIC_API_CUSTOMER_URL || '',

  // Store Configuration
  storeId: process.env.NEXT_PUBLIC_STORE_ID || '',

  // Newsletter Configuration
  newsletter: {
    merchantId: process.env.NEXT_PUBLIC_MERCHANT_ID || '',
  },

  // KwikPass Configuration
  kwikpass: {
    userToken: process.env.NEXT_PUBLIC_KWIKPASS_USER_TOKEN || '',
    userCoreToken: process.env.NEXT_PUBLIC_KWIKPASS_USER_CORE_TOKEN || '',
  },

  // GoKwik Configuration
  gokwik: {
    environment: process.env.NEXT_PUBLIC_GOKWIK_ENVIRONMENT || '',
    type: process.env.NEXT_PUBLIC_GOKWIK_TYPE || '',
    mid: process.env.NEXT_PUBLIC_GOKWIK_MID || '',
    phoneNumber: process.env.NEXT_PUBLIC_GOKWIK_PHONE || '',
    scriptUrl: process.env.NEXT_PUBLIC_GOKWIK_SCRIPT_BASE_URL,
    bannerMessages: [
      process.env.NEXT_PUBLIC_GOKWIK_BANNER_MESSAGE_1 || '',
      process.env.NEXT_PUBLIC_GOKWIK_BANNER_MESSAGE_2 || '',
    ],
  },
};